<template>
  <div class="mb-4 flex flex-col justify-between space-y-4 md:flex-row md:space-y-0">
    <div v-if="pagination" class="m-2 flex flex-row">
      <UiSkeleton v-if="isLoading" class="h-6 w-40" />
      <UiText v-else class="text-neutral-600">
        {{
          $t('productList.resultCount', {
            start: pagination.limit * (pagination.page - 1) + 1,
            end: pagination.limit * (pagination.page - 1) + pagination.count,
            total: pagination.total,
          })
        }}
      </UiText>
    </div>
    <div class="flex flex-row">
      <UiTooltip
        id="product-list-settings-sort-dir"
        :label="sortDirection === SortDirection.ASC ? $t('productList.sortDirAsc') : $t('productList.sortDirDesc')"
        placement="top"
      >
        <UiIconButton
          id="product-list-settings-sort-dir"
          :icon="sortDirection === SortDirection.ASC ? IconSortAscending : IconSortDescending"
          variant="secondary"
          border
          rounded
          class="mr-2"
          @click="toggleSortDirection()"
        />
      </UiTooltip>
      <UiSelect
        id="product-list-settings-sort"
        :model-value="sortBy"
        wrapper-class="w-full"
        @update:model-value="setSortBy"
      >
        <option v-for="value in sortValues" :key="value" :value="value">
          {{ $t(`productList.filters.sort.${value}`) }}
        </option>
      </UiSelect>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IconSortAscending, IconSortDescending } from '#components';

import type { ProductListSettingsProps } from '~/components/ProductList/types';

import { ProductSort, SortDirection } from '~/stores/category/types';

const sortValues = ref<string[]>(Object.values(ProductSort));

defineProps<ProductListSettingsProps>();
</script>
